<script setup lang="ts">
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import { useSimpleTextTooltip } from '@/common/components/molecules/simpleTextTooltip/simpleTextTooltip.uses';
import SimpleTextTooltip from '@/common/components/molecules/simpleTextTooltip/SimpleTextTooltip.vue';
import { useInternational } from '@/common/locale';
import { computed, ref } from 'vue';

interface Props {
  useTooltip?: boolean;
  disabled?: boolean;
  title?: string;
}

interface Emits {
  (e: 'click', value: Event): void;
}

const props = withDefaults(defineProps<Props>(), {
  useTooltip: true,
  disabled: false,
  title: undefined,
});
const emit = defineEmits<Emits>();

const { t } = useInternational();

const titleText = computed(() => props.title ?? t('WORD.COPY'));
const onClickCopy = (e: Event) => {
  emit('click', e);
};
const tooltipEvent = ref<MouseEvent | null>(null);
const { onMouseEventInTarget } = useSimpleTextTooltip(tooltipEvent);
const onMouseEvent = (e: MouseEvent) => {
  if (!props.useTooltip) {
    return;
  }
  onMouseEventInTarget(e);
};
</script>

<template>
  <base-button
    class="chart-data-copy-button"
    type="icon"
    :disabled="props.disabled"
    :title="titleText"
    @click="onClickCopy"
    @mouseenter="onMouseEvent"
    @mouseleave="onMouseEvent"
  >
    <ev-icon icon="icon-outline-copy" />
    <simple-text-tooltip
      v-if="props.useTooltip"
      :mouse-event="tooltipEvent"
      base-pos="bottom"
      responsive-pos
    >
      {{ t('WORD.COPY') }}
    </simple-text-tooltip>
  </base-button>
</template>
